import { userLogin } from '~/stores/userLogin'
import { personalInfoName, platFormName, tokenName } from '~/stores/tokenName'


export function initCookie() {
  const token = useCookie(tokenName);
  const phone = useCookie('phone');
  const personalInfo = useCookie(personalInfoName);
  const platForm = useCookie(platFormName);

  if (phone.value) {
    phone.value = null;
  }
  if (personalInfo.value) {
    personalInfo.value = null;
  }

  if(platForm.value) {
    platForm.value = '2';
  }

  if (token.value) {
    token.value = null;
    const loginStore = userLogin();
    loginStore.isLogin = false;
  }

  const router = useRouter();
  router.push('/'); // 重定向到首页
}

